import { useState, useEffect } from "react";
import { getCweTags } from "sj-ui-toolkit/src/api";

interface CweTag {
  cweTag?: {
    name?: string;
  };
}

interface TagsData {
  cweTags?: CweTag[];
}

interface CweDataEntry {
  Name: string;
  Description: string;
}
type CweData = Record<number, CweDataEntry>;

export interface MappedCweTag {
  value: number;
  name: string;
  description: string | null;
}

export const useCweTags = (tagsData: TagsData): MappedCweTag[] => {
  const [cweTags, setCweTags] = useState<MappedCweTag[]>([]);

  useEffect(() => {
    const cweIdsInUse =
      tagsData.cweTags
        ?.map(cwe => parseInt(cwe.cweTag?.name?.replace("CWE-", "") ?? "", 10))
        .filter(n => !isNaN(n)) ?? [];

    if (cweIdsInUse.length === 0) {
      setCweTags([]);
      return;
    }

    const loadCweTags = async () => {
      try {
        const cweData: CweData = await getCweTags();
        const mapped = cweIdsInUse
          .map(cweNumber => {
            const cweInfo = cweData[cweNumber];
            return {
              value: cweNumber,
              name: cweInfo ? `CWE-${cweNumber}: ${cweInfo.Name}` : `CWE-${cweNumber}`,
              description: cweInfo?.Description ?? null,
            };
          })
          .filter((t): t is MappedCweTag => t !== null);
        setCweTags(mapped);
      } catch (error) {
        console.error("Failed to load CWE tags:", error);
      }
    };

    void loadCweTags();
  }, [tagsData]);

  return cweTags;
};
